module.exports = __webpack_public_path__ + "img/doubleTicket_checked.18fd8ec1.png";